export default __webpack_public_path__ + "static/media/multiweekIcon.44e97b94.svg";